import styles from './MainText.module.css'
import { Col, Row } from "react-bootstrap"

export default function MainText() {
    return (
        <section>
            <Row className="m-auto justify-content-center mt-5 pt-5">
                <Col xs="11" sm="12" md="12" lg="5">
                    <h1 className={ `${styles.title} text-start text-sm-center` }>
                        The art of <span className={ styles.qanelasBoldItalic }>innovation.</span>
                        <br />
                        The power of <span className={ styles.qanelasBoldItalic }>performance.</span>
                    </h1>

                    <p className={ `${ styles.text } text-start text-sm-center mt-5` }>
                    MONO has taken a bold path in the ever-evolving automotive industry, thriving through strategic decisions and rapid adaptability. Under the visionary leadership of Francois Bandura, MONO continues to push boundaries in the trim decor sector, embracing innovation and speed. <span className={ styles.montserratBold }>The <i className={ styles.montserratBoldItalic }>challenge</i> is set. The <i className={ styles.montserratBoldItalic }>competition</i> is fierce. The <i className={ styles.montserratBoldItalic }>future</i> is</span> MONO.
                    </p>
                </Col>
            </Row>
        </section>
    )
}